import type { Option } from '@/types/Product';

/** Détecte l'option ecommerce couleur (type "Color", "Couleur", ou nom "couleur"). */
export function isEcommerceColorOption(option: Option): boolean {
    const type = (option.type ?? '').toLowerCase().trim();
    const name = (option.name ?? '').toLowerCase().trim();
    return (
        type.startsWith('color') || type.startsWith('couleur') || name.startsWith('couleur') || name.startsWith('color')
    );
}

export function findEcommerceColorOption(options: Option[] | undefined): Option | undefined {
    return options?.find(isEcommerceColorOption);
}
